import PropTypes from 'prop-types';
import React from 'react';
import styled from '@utils/styled-px2rem';

import Button from '../Button';

class Tab extends React.PureComponent {
  render() {
    const {
      autoFocus,
      children,
      functional: isFunctional,
      ...props
    } = this.props;

    const tab = isFunctional ? <li /> : <StyledTab />;
    const content = (
      <StyledButton autoFocus={autoFocus} functional>
        {children}
      </StyledButton>
    );

    return React.cloneElement(tab, props, content);
  }
}

Tab.propTypes = {
  autoFocus: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  functional: PropTypes.bool,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
  value: PropTypes.string.isRequired,
};

Tab.defaultProps = {
  autoFocus: false,
  children: '',
  className: '',
  disabled: false,
  functional: false,
  onClick: Function.prototype,
  selected: false,
};

const StyledTab = styled.li`
  background-color: #e6e6e6;
  border: 1px solid #919499;
  border-radius: 4px;
  box-sizing: content-box;

  ${props =>
    props.selected &&
    `
    background-color: #fff;
    border-color: transparent;
  `}

  ${props =>
    props.disabled &&
    `
    cursor: not-allowed;
    pointer-events: none;
    opacity: .4;
  `}
`;

const StyledButton = styled(Button)`
  border-radius: inherit;
  height: 100%;
  width: 100%;

  > * {
    border-radius: inherit;
  }
`;

export default Tab;
